import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import {getMobileAppTypeImpl, isInIframe, isIosReviewMode, isMobileApp, mobileGeolocationEnabled} from "./foreign.js";
const $AppType = tag => ({tag});
const IosWebPage = /* #__PURE__ */ $AppType("IosWebPage");
const IosMobileApp = /* #__PURE__ */ $AppType("IosMobileApp");
const getMobileAppType = () => {
  const appType = getMobileAppTypeImpl();
  return (() => {
    if (appType === "IosWebPage") { return Data$dMaybe.$Maybe("Just", IosWebPage); }
    if (appType === "IosMobileApp") { return Data$dMaybe.$Maybe("Just", IosMobileApp); }
    return Data$dMaybe.Nothing;
  })();
};
const isAndroid = () => {
  const isMobileApp$p = isMobileApp();
  const iosAppType = getMobileAppType();
  return (() => {
    if (iosAppType.tag === "Just") { return false; }
    if (iosAppType.tag === "Nothing") { return isMobileApp$p; }
    $runtime.fail();
  })();
};
const eqAppType = {
  eq: x => y => {
    if (x.tag === "IosWebPage") { return y.tag === "IosWebPage"; }
    if (x.tag === "IosMobileApp") { return y.tag === "IosMobileApp"; }
    return false;
  }
};
export {$AppType, IosMobileApp, IosWebPage, eqAppType, getMobileAppType, isAndroid};
export * from "./foreign.js";
